// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("cursor.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/handpointing.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Importa a fonte Roboto */

:root {
  --background-color: #ffffff;
  --text-color: #000000;
  --link-color: #000000;
  --link-hover-color: #000000;
  --footer-background-color: #f1f1f1;
}

.dark-mode {
  --background-color: #121212;
  --text-color: #ffffff;
  --link-color: #ffffff;
  --link-hover-color: #ffffff;
  --footer-background-color: #333333;
}

* {
  font-family: 'Roboto Mono', monospace;
  transition: background-color 0.3s, color 0.3s; /* Adiciona transição suave */
}

body {
  background-color: var(--background-color);
  color: var(--text-color);
  transition: background-color 0.3s, color 0.3s; /* Adiciona transição suave */
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto; /* Use o caminho absoluto */ /* Certifique-se de que o caminho está correto */
  
}

a, button, [role="button"], label {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer; /* Cursor customizado para clique */
}

a {
  color: var(--link-color);
  transition: color 0.3s; /* Adiciona transição suave */
}

a:hover {
  color: var(--link-hover-color);
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Cor de fundo semitransparente */
  -webkit-backdrop-filter: blur(1px);
          backdrop-filter: blur(1px); /* Aplica o desfoque */
  z-index: 100; /* Certifique-se de que esteja acima de outros elementos */
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff; /* Cor do fundo do modal */
  padding: 20px;
  z-index: 101; /* Certifique-se de que esteja acima do fundo desfocado */
}

.body {
  overflow: hidden;
  background: #fff;
}

.setup, .oi, .info, .lastscrobble, .steam-group {
  display: flex;
  justify-content: center;
  gap: 15px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
}

.wrapper {
  height: 100vh;
  /*This part is important for centering*/
  place-items: center;
  display: grid;
}

.wrap-2 {
  margin-top: 290px;
  width: 100%;
  text-align: center;
  /*This part is important for centering*/
  place-items: center;
  font-size: 150%;
  justify-content: center;
}

.wrap-3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  text-align: center;
  padding: 20px; /* Espaçamento interno para melhor aparência */
  font-size: 150%;
}

.info-socials {
  place-items: center;
  width: 100%;
  text-align: center;
  font-size: 150%;
  justify-content: center;
}

.aboutme-header {
  font-size: 2em; /* Ajuste conforme necessário */
  text-align: center;
  margin-bottom: 20px; /* Espaçamento abaixo do cabeçalho */
  color: var(--text-color);
}

.aboutme-text {
  font-size: 0.6em; /* Ajuste conforme necessário para compatibilidade */
  display: block;
  text-align: center;
  margin: 0 auto;
  max-width: 800px; /* Limite a largura máxima para melhor legibilidade */
  line-height: 1.5; /* Espaçamento entre linhas para melhor legibilidade */
  color: var(--text-color);
}

@media (max-width: 1200px) {
  .aboutme-text {
    font-size: 1.1em;
  }
}

@media (max-width: 992px) {
  .aboutme-text {
    font-size: 1em;
  }
}

@media (max-width: 768px) {
  .aboutme-text {
    font-size: 0.9em;
  }
}

@media (max-width: 576px) {
  .aboutme-text {
    font-size: 0.8em;
  }
}

.socials-text {
  font-size: 150%;
  display: flex;
  bottom: 50%; /* Adiciona uma separação de 50px */
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: 3px solid;
  width: 45%;
  white-space: nowrap; /* Keeps the content on a single line */
  letter-spacing: .03em; /* Adjust as needed */
  animation: 
    typing 3s steps(45),
    cursor .4s step-end infinite alternate;
  color: var(--text-color);
}

.aboutme-header {
  bottom: 50%; /* Adiciona uma separação de 50px */
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: 3px solid;
  width: 15%;
  white-space: nowrap; /* Keeps the content on a single line */
  letter-spacing: .03em; /* Adjust as needed */
  animation: 
    typing 1s steps(9),
    cursor .4s step-end infinite alternate;
  color: var(--text-color);
}

.typing-demo {
  bottom: 50%; /* Adiciona uma separação de 50px */
  overflow: hidden; /* Ensures the content is not revealed until the animation */
  border-right: 3px solid;
  width: 100%;
  white-space: nowrap; /* Keeps the content on a single line */
  letter-spacing: .03em; /* Adjust as needed */
  animation: 
    typing 1s steps(8),
    cursor .4s step-end infinite alternate;
  color: var (--text-color);
}

@keyframes cursor {
  50% { border-color: transparent; }
}

@keyframes typing {
  from { width: 0; }
}

.oi {
  bottom: 120px; /* Adiciona uma separação de 50px */
}

.info a {
  color: var(--text-color);
  margin-bottom: 90px;
}

.lastscrobble {
  align-items: center;
  margin-bottom: 20px; /* Adiciona uma separação de 50px + 20px existente */
}

.lastscrobble img {
  width: 50px;
  height: 50px;
  margin-left: 10px;
}

.lastscrobble p {
  margin: 0;
  color: var(--text-color);
}

.steam-group {
  bottom: 130px; /* Adiciona uma separação de 50px + 80px existente */
  left: 40px;
}

.art {
  position: absolute;
  height: 100vh;
  max-width: 30vw;
  right: 1vh;
  bottom: 0vh;
  object-fit: contain;
}

.twitch-profile-container {
  display: flex;
}

.twitch-status {
  margin-left: 10px;
  margin-top: 4px;
  font-size: 80%;
  color: var(--text-color);
}

.dark-mode-toggle {
  position: fixed;
  top: 10px;
  right: 10px;
  padding: 10px 20px;
  background-color: var(--background-color);
  color: var(--text-color);
  border: 1px solid var(--text-color);
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer;
  transition: background-color 0.3s, color 0.3s; /* Adiciona transição suave */
  z-index: 1000; /* Ensure the button is on top of other elements */
}

.dark-mode-toggle:hover {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer; /* Cursor customizado para clique */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAG3B;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,6CAA6C,EAAE,6BAA6B;AAC9E;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,6CAA6C,EAAE,6BAA6B;EAC5E,qDAA+B,EAAE,2BAA2B,EAAE,gDAAgD;;AAEhH;;AAEA;EACE,wDAAiD,EAAE,mCAAmC;AACxF;;AAEA;EACE,wBAAwB;EACxB,sBAAsB,EAAE,6BAA6B;AACvD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,kCAAkC;EAClE,kCAA0B;UAA1B,0BAA0B,EAAE,sBAAsB;EAClD,YAAY,EAAE,0DAA0D;AAC1E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB,EAAE,0BAA0B;EAC5C,aAAa;EACb,YAAY,EAAE,yDAAyD;AACzE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,aAAa,EAAE,8CAA8C;EAC7D,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc,EAAE,+BAA+B;EAC/C,kBAAkB;EAClB,mBAAmB,EAAE,oCAAoC;EACzD,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB,EAAE,oDAAoD;EACtE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB,EAAE,qDAAqD;EACvE,gBAAgB,EAAE,sDAAsD;EACxE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW,EAAE,mCAAmC;EAChD,gBAAgB,EAAE,4DAA4D;EAC9E,uBAAuB;EACvB,UAAU;EACV,mBAAmB,EAAE,uCAAuC;EAC5D,qBAAqB,EAAE,qBAAqB;EAC5C;;0CAEwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,gBAAgB,EAAE,4DAA4D;EAC9E,uBAAuB;EACvB,UAAU;EACV,mBAAmB,EAAE,uCAAuC;EAC5D,qBAAqB,EAAE,qBAAqB;EAC5C;;0CAEwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,gBAAgB,EAAE,4DAA4D;EAC9E,uBAAuB;EACvB,WAAW;EACX,mBAAmB,EAAE,uCAAuC;EAC5D,qBAAqB,EAAE,qBAAqB;EAC5C;;0CAEwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,MAAM,yBAAyB,EAAE;AACnC;;AAEA;EACE,OAAO,QAAQ,EAAE;AACnB;;AAEA;EACE,aAAa,EAAE,mCAAmC;AACpD;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB,EAAE,oDAAoD;AAC3E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa,EAAE,oDAAoD;EACnE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;EACxB,mCAAmC;EACnC,wDAAiD;EACjD,6CAA6C,EAAE,6BAA6B;EAC5E,aAAa,EAAE,kDAAkD;AACnE;;AAEA;EACE,wDAAiD,EAAE,mCAAmC;AACxF","sourcesContent":["/* Importa a fonte Roboto */\n@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;700&display=swap');\n\n:root {\n  --background-color: #ffffff;\n  --text-color: #000000;\n  --link-color: #000000;\n  --link-hover-color: #000000;\n  --footer-background-color: #f1f1f1;\n}\n\n.dark-mode {\n  --background-color: #121212;\n  --text-color: #ffffff;\n  --link-color: #ffffff;\n  --link-hover-color: #ffffff;\n  --footer-background-color: #333333;\n}\n\n* {\n  font-family: 'Roboto Mono', monospace;\n  transition: background-color 0.3s, color 0.3s; /* Adiciona transição suave */\n}\n\nbody {\n  background-color: var(--background-color);\n  color: var(--text-color);\n  transition: background-color 0.3s, color 0.3s; /* Adiciona transição suave */\n  cursor: url('cursor.png'), auto; /* Use o caminho absoluto */ /* Certifique-se de que o caminho está correto */\n  \n}\n\na, button, [role=\"button\"], label {\n  cursor: url('./assets/handpointing.png'), pointer; /* Cursor customizado para clique */\n}\n\na {\n  color: var(--link-color);\n  transition: color 0.3s; /* Adiciona transição suave */\n}\n\na:hover {\n  color: var(--link-hover-color);\n}\n\n.modal-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Cor de fundo semitransparente */\n  backdrop-filter: blur(1px); /* Aplica o desfoque */\n  z-index: 100; /* Certifique-se de que esteja acima de outros elementos */\n}\n\n.modal-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff; /* Cor do fundo do modal */\n  padding: 20px;\n  z-index: 101; /* Certifique-se de que esteja acima do fundo desfocado */\n}\n\n.body {\n  overflow: hidden;\n  background: #fff;\n}\n\n.setup, .oi, .info, .lastscrobble, .steam-group {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  text-align: center;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.wrapper {\n  height: 100vh;\n  /*This part is important for centering*/\n  place-items: center;\n  display: grid;\n}\n\n.wrap-2 {\n  margin-top: 290px;\n  width: 100%;\n  text-align: center;\n  /*This part is important for centering*/\n  place-items: center;\n  font-size: 150%;\n  justify-content: center;\n}\n\n.wrap-3 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100%;\n  text-align: center;\n  padding: 20px; /* Espaçamento interno para melhor aparência */\n  font-size: 150%;\n}\n\n.info-socials {\n  place-items: center;\n  width: 100%;\n  text-align: center;\n  font-size: 150%;\n  justify-content: center;\n}\n\n.aboutme-header {\n  font-size: 2em; /* Ajuste conforme necessário */\n  text-align: center;\n  margin-bottom: 20px; /* Espaçamento abaixo do cabeçalho */\n  color: var(--text-color);\n}\n\n.aboutme-text {\n  font-size: 0.6em; /* Ajuste conforme necessário para compatibilidade */\n  display: block;\n  text-align: center;\n  margin: 0 auto;\n  max-width: 800px; /* Limite a largura máxima para melhor legibilidade */\n  line-height: 1.5; /* Espaçamento entre linhas para melhor legibilidade */\n  color: var(--text-color);\n}\n\n@media (max-width: 1200px) {\n  .aboutme-text {\n    font-size: 1.1em;\n  }\n}\n\n@media (max-width: 992px) {\n  .aboutme-text {\n    font-size: 1em;\n  }\n}\n\n@media (max-width: 768px) {\n  .aboutme-text {\n    font-size: 0.9em;\n  }\n}\n\n@media (max-width: 576px) {\n  .aboutme-text {\n    font-size: 0.8em;\n  }\n}\n\n.socials-text {\n  font-size: 150%;\n  display: flex;\n  bottom: 50%; /* Adiciona uma separação de 50px */\n  overflow: hidden; /* Ensures the content is not revealed until the animation */\n  border-right: 3px solid;\n  width: 45%;\n  white-space: nowrap; /* Keeps the content on a single line */\n  letter-spacing: .03em; /* Adjust as needed */\n  animation: \n    typing 3s steps(45),\n    cursor .4s step-end infinite alternate;\n  color: var(--text-color);\n}\n\n.aboutme-header {\n  bottom: 50%; /* Adiciona uma separação de 50px */\n  overflow: hidden; /* Ensures the content is not revealed until the animation */\n  border-right: 3px solid;\n  width: 15%;\n  white-space: nowrap; /* Keeps the content on a single line */\n  letter-spacing: .03em; /* Adjust as needed */\n  animation: \n    typing 1s steps(9),\n    cursor .4s step-end infinite alternate;\n  color: var(--text-color);\n}\n\n.typing-demo {\n  bottom: 50%; /* Adiciona uma separação de 50px */\n  overflow: hidden; /* Ensures the content is not revealed until the animation */\n  border-right: 3px solid;\n  width: 100%;\n  white-space: nowrap; /* Keeps the content on a single line */\n  letter-spacing: .03em; /* Adjust as needed */\n  animation: \n    typing 1s steps(8),\n    cursor .4s step-end infinite alternate;\n  color: var (--text-color);\n}\n\n@keyframes cursor {\n  50% { border-color: transparent; }\n}\n\n@keyframes typing {\n  from { width: 0; }\n}\n\n.oi {\n  bottom: 120px; /* Adiciona uma separação de 50px */\n}\n\n.info a {\n  color: var(--text-color);\n  margin-bottom: 90px;\n}\n\n.lastscrobble {\n  align-items: center;\n  margin-bottom: 20px; /* Adiciona uma separação de 50px + 20px existente */\n}\n\n.lastscrobble img {\n  width: 50px;\n  height: 50px;\n  margin-left: 10px;\n}\n\n.lastscrobble p {\n  margin: 0;\n  color: var(--text-color);\n}\n\n.steam-group {\n  bottom: 130px; /* Adiciona uma separação de 50px + 80px existente */\n  left: 40px;\n}\n\n.art {\n  position: absolute;\n  height: 100vh;\n  max-width: 30vw;\n  right: 1vh;\n  bottom: 0vh;\n  object-fit: contain;\n}\n\n.twitch-profile-container {\n  display: flex;\n}\n\n.twitch-status {\n  margin-left: 10px;\n  margin-top: 4px;\n  font-size: 80%;\n  color: var(--text-color);\n}\n\n.dark-mode-toggle {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  padding: 10px 20px;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  border: 1px solid var(--text-color);\n  cursor: url('./assets/handpointing.png'), pointer;\n  transition: background-color 0.3s, color 0.3s; /* Adiciona transição suave */\n  z-index: 1000; /* Ensure the button is on top of other elements */\n}\n\n.dark-mode-toggle:hover {\n  cursor: url('./assets/handpointing.png'), pointer; /* Cursor customizado para clique */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
